import type { ReactNode } from 'react';
import { flex } from '../../../../styled-system/patterns';

export function TermsLayout({ children }: { children: ReactNode }) {
  return (
    <div
      className={flex({
        width: '100%',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: '{spacing.20}',
        paddingBottom: '{spacing.40}',
        sm: {
          paddingTop: '{spacing.40}',
          paddingBottom: '{spacing.56}',
        },
      })}
    >
      {children}
    </div>
  );
}
